<template>
  <div class="invite-panel-wrapper">
    <div class="component-container">
      <div class="container-head contain-btn-title">
        <div class="invite-head-title-panel container-head-title">
          <span class="invite-head-title"
            >邀请码(共 <span style="color: #FA907A">{{ total }}</span> 个)
            <!--| 已使用 <span
            style="color: #FA907A">{{ usedCount }}</span> 个 ，<span style="color: #FA907A">{{ notUseCount }}</span> 个未使用)-->
          </span>

          <span class="invite-head-opt-btn">
            <common-button
              size="default"
              :loading="saveLoading"
              type="primary"
              image
              @click="handleGenerateInvite"
              >生成邀请码</common-button
            >
            <common-button
              class="icon-daoru iconfont"
              type="primary"
              image
              @click="exportExcel()"
              >导出</common-button
            >
          </span>
        </div>
      </div>
      <div class="invite-body">
        <el-table
          row-class-name="vertical-align-top"
          :data="userInviteCodes"
          style="width: 100%"
        >
          <el-table-column sortable width="220" prop="code" label="邀请码">
            <template slot-scope="scope">
              <i
                class="icon-fuzhi1 iconfont"
                @click="handleCopy(scope.row.code)"
                style="cursor: pointer"
              ></i>
              <span>{{ scope.row.code }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="link" label="邀请链接">
            <template slot-scope="scope">
              <i
                class="icon-fuzhi1 iconfont"
                @click="handleCopy(scope.row.link)"
                style="cursor: pointer"
              ></i>
              <span>{{ scope.row.link }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="100"
            prop="link"
            label="二维码"
          >
            <template slot-scope="scope">
              <span title="点击查看二维码">
                <span
                  class="qrcode icon-erweima2 iconfont"
                  @click="showQRCode(scope.row)"
                ></span>
              </span>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            align="center"
            prop="isUsed"
            width="150"
            label="使用次数"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.userCount }}</span>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            align="center"
            width="180"
            prop="createTime"
            label="创建时间"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | datetimeFormat }}</span>
            </template>
          </el-table-column>
          <el-table-column
            sortable
            align="center"
            width="180"
            prop="expireTime"
            label="过期时间"
          >
            <template slot-scope="scope">
              <span v-if="!scope.row.expireTime">永不过期</span>
              <span v-if="scope.row.expireTime">{{
                scope.row.expireTime | datetimeFormat
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            align="center"
            width="80"
            prop="expireTime"
            label="操作"
          >
            <template slot-scope="scope">
              <button
                class="eims-button eims-button--text"
                @click="handleDeleteInvite(scope.row)"
              >
                删除
              </button>
            </template>
          </el-table-column>
        </el-table>
        <div class="invite-table-foot">
          <div class="invite-pagination">
            <el-pagination
              layout="sizes, prev, pager, next"
              :total="total"
              :current-page="pageNum"
              :page-size="pageSize"
              :page-sizes="pageSizeArray"
              @current-change="clickChangePage"
              @size-change="handleSizeChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>

    <common-dialog
      title="生成邀请码"
      :visible.sync="showGenerateVisible"
      width="500px"
    >
      <span>
        <div style="width: 100%;text-align: left;padding-left: 40px">
          <div style="width: 100%">
            有效期：
            <el-radio-group v-model="inviteCode.period">
              <el-radio :label="1">1 天</el-radio>
              <el-radio :label="3">3天</el-radio>
              <el-radio :label="7">7天</el-radio>
              <el-radio :label="0">永不过期</el-radio>
            </el-radio-group>
          </div>
        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <common-button @click="showGenerateVisible = false" type="cancel"
          >取 消</common-button
        >
        <common-button
          type="primary"
          @click="generateInviteCode"
          :loading="saveLoading"
          >确 定</common-button
        >
      </span>
    </common-dialog>

    <q-r-code :item="invite" v-model="qRCodeDialogVisible"></q-r-code>

    <animation
      :loadingDataVisible="loadingVisible"
      :loadingText="loadingText"
    />
  </div>
</template>

<script>
import animation from "@/components/loading/animation";
import http from "@/utils/axios";
import cookie from "@/utils/cookie";
import * as XLSX from "xlsx";
import QRCode from "@/components/uCenter/QRCode";
import { Message } from "element-ui";
import { PAGE_SIZE_ARRAY } from "@/constants/constants";

export default {
  name: "InviteList",
  components: { QRCode, animation },
  data() {
    return {
      showGenerateVisible: false,
      inviteCode: {
        period: 1
      },
      loadingText: "加载中",
      //按钮设置加载中
      saveLoading: false,
      userInviteCodes: [],
      excelData: [],
      total: 0,
      usedCount: 0,
      notUseCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageSizeArray: PAGE_SIZE_ARRAY,
      loadingVisible: false,
      qRCodeDialogVisible: false,
      invite: {}
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    handleDeleteInvite(row) {
      this.$confirm(`确定将邀请码 ${row.code} 删除?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadingText = "删除中";
          this.loadingVisible = true;
          let token = cookie.getCookie("token");
          http
            .post(
              window.config.api.baseUrl + "/eims-api/inviteCode/deleteByCode",
              {
                token: token,
                data: {
                  code: row.code
                }
              }
            )
            .then(response => {
              this.loadingVisible = false;
              if (response.data.code === "00000") {
                this.initData();
                Message.success({
                  message: "邀请码删除成功！",
                  showClose: true
                });
              }
            })
            .catch(reason => {
              this.loadingVisible = false;
            });
        })
        .catch(() => {});
    },

    generateInviteCode() {
      this.loadingText = "生成中";
      this.saveLoading = true;
      this.loadingVisible = true;
      let token = cookie.getCookie("token");
      http
        .post(window.config.api.baseUrl + "/eims-api/inviteCode/generate", {
          token: token,
          data: {
            period: this.inviteCode.period
          }
        })
        .then(response => {
          this.loadingVisible = false;
          if (response.data.code === "00000") {
            this.initData();
            Message.success({ message: "邀请码生成成功！", showClose: true });
          }
        })
        .finally(() => {
          this.showGenerateVisible = false;
          this.saveLoading = false;
        })
        .catch(reason => {
          this.loadingVisible = false;
        });
    },

    handleGenerateInvite() {
      this.showGenerateVisible = true;
    },

    //显示二维码
    showQRCode(row) {
      this.invite = row;
      this.qRCodeDialogVisible = true;
    },

    exportExcel() {
      http
        .post(window.config.api.baseUrl + "/eims-api/inviteCode/findByUserId", {
          token: cookie.getCookie("token"),
          data: {
            pageNum: 1,
            pageSize: 1000
          }
        })
        .then(response => {
          if (response.data.code === "00000") {
            this.excelData = [];
            this.excelData.push(["邀请链接", "邀请码"]);
            let repData = response.data.data;
            let userId = null;
            for (let data of repData.userInviteCodes) {
              let item = [];
              item.push(
                window.location.origin + "/#/register?inviteCode=" + data.code
              );
              item.push(data.code);
              if (!userId) {
                userId = data.userId;
              }
              this.excelData.push(item);
            }

            if (this.excelData.length !== 1) {
              //1、定义导出文件名称
              let filename = `用户-${userId}的邀请码.xlsx`;
              // 定义导出数据
              // 定义excel文档的名称
              let ws_name = "SheetJS";
              // 初始化一个excel文件
              let wb = XLSX.utils.book_new();
              // 初始化一个excel文档，此时需要传入数据

              let ws = XLSX.utils.aoa_to_sheet(this.excelData);
              // 将文档插入文件并定义名称
              XLSX.utils.book_append_sheet(wb, ws, ws_name);
              // 执行下载
              XLSX.writeFile(wb, filename);
            } else {
              this.$message.warning("您没有邀请码！");
            }
          }
        });
    },

    //点击改变页码
    clickChangePage(pageNum) {
      this.pageNum = pageNum;
      this.initData();
    },

    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData();
    },

    //页码改变之后
    changePage(pageNum) {
      this.pageNum = pageNum;
    },

    handleCopy(content) {
      // 创建输入框元素
      let oInput = document.createElement("input");
      // 将想要复制的值
      oInput.value = content;
      // 页面底部追加输入框
      document.body.appendChild(oInput);
      // 选中输入框
      oInput.select();
      // 执行浏览器复制命令
      document.execCommand("Copy");
      // 弹出复制成功信息
      Message.success({ message: "复制成功！", showClose: true });
      // 复制后移除输入框
      oInput.remove();
    },

    initData() {
      this.loadingText = "加载中";
      this.loadingVisible = true;
      http
        .post(window.config.api.baseUrl + "/eims-api/inviteCode/findByUserId", {
          token: cookie.getCookie("token"),
          data: {
            pageNum: this.pageNum,
            pageSize: this.pageSize
          }
        })
        .then(response => {
          if (response.data.code === "00000") {
            this.userInviteCodes = [];
            let repData = response.data.data;
            this.total = repData.total;
            this.usedCount = repData.usedCount;
            this.notUseCount = repData.notUseCount;
            for (let data of repData.userInviteCodes) {
              data.link =
                window.location.origin + "/#/register?inviteCode=" + data.code;
              this.userInviteCodes.push(data);
            }
          }
        })
        .finally(() => {
          this.loadingVisible = false;
        });
    }
  }
};
</script>

<style scoped>
.invite-panel-wrapper {
  background-color: #fff;
  border-radius: 10px;
}

.invite-head {
  height: 100px;
  width: 100%;
  border-bottom: 1px solid salmon;
}

.invite-body {
  margin: 10px;
  height: calc(100% - 140px);
  border-radius: 10px;
}

.invite-head-title {
  align-self: start;
  margin-left: 20px;
  float: left;
}

.invite-head-opt-btn {
}

.invite-head-count {
  float: right;
  margin-right: 50px;
}

.invite-table-foot {
  background-color: #fff;
  height: 40px;
}

.invite-pagination {
  float: right;
  padding-top: 4px;
  padding-right: 40px;
  height: 40px;
}

.invite-head-title-panel > * {
  vertical-align: middle;
}

.invite-head-title-panel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(100vw - 100px);
  /*height: 40px;*/
}

.invite-head-handle-panel {
  padding-left: 40px;
  width: 100%;
  height: 40px;
}

.exportBtn:before {
  padding: 0 10px;
}

.exportBtn {
  background-image: url("/static/images/btn_tow_word.png");
  background-color: rgb(102, 172, 242);
  border: transparent;
  border-radius: 5px;
  padding: 0 10px;
  height: 35px;
  box-shadow: 1px 1px 5px rgb(0, 117, 248);
}

.exportBtn:hover {
  background-color: rgb(33, 139, 243);
}

.exportBtn:active {
  background-color: rgb(0, 117, 248);
}

.qrcode {
  cursor: pointer;
}

.qrcode:hover {
  color: rgb(0, 117, 248);
}

/*将图标放在后面*/
.icon-fuzhi1 {
  color: rgb(94, 213, 217);
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/user/group/InviteList.vue